import React from "react";
import { MapPin } from "lucide-react";
import { CLIENTS } from "../data/mock";
import Reveal from "./Reveal";

const ClientsSection = () => {
  const d = CLIENTS;
  return (
    <section className="bg-[var(--cream-2)] py-24 md:py-32">
      <div className="max-w-[1280px] mx-auto px-6 md:px-8">
        <div className="max-w-2xl mb-16">
          <Reveal>
            <div className="eyebrow mb-4">{d.eyebrow}</div>
          </Reveal>
          <Reveal delay={80}>
            <h2 className="font-serif text-[38px] md:text-[52px] font-semibold leading-[1.05] text-[#14161c] mb-6">
              {d.title}
            </h2>
          </Reveal>
          <Reveal delay={140}>
            <p className="text-[#55585f] leading-relaxed">{d.intro}</p>
          </Reveal>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {d.items.map((c, i) => (
            <Reveal key={c.name} delay={i * 100}>
              <div className="group bg-white border border-black/5 rounded-sm p-8 h-full flex flex-col shadow-[0_20px_50px_-30px_rgba(20,22,28,0.25)] hover:-translate-y-1.5 hover:shadow-[0_30px_60px_-30px_rgba(20,22,28,0.35)] transition-all duration-400">
                {/* client logo plate */}
                <div className="w-full h-24 rounded-sm bg-white border border-black/5 flex items-center justify-center mb-7 shrink-0 px-6">
                  <img
                    src={c.logo}
                    alt={`${c.name} logo`}
                    className="max-h-14 max-w-full object-contain"
                  />
                </div>

                <h3 className="font-serif text-xl md:text-[22px] font-semibold text-[#14161c] leading-snug">
                  {c.name}
                </h3>
                <div className="flex items-center gap-2 text-[#55585f] text-sm mt-3">
                  <MapPin size={15} className="text-[var(--gold)]" />
                  {c.location}
                </div>

                {c.desc && (
                  <p className="text-[#55585f] text-sm leading-relaxed mt-5 pt-5 border-t border-black/5">
                    {c.desc}
                  </p>
                )}

                <div className="mt-auto pt-7">
                  <div className="h-1 w-10 bg-[var(--gold)]/60 rounded-full group-hover:w-16 transition-all duration-400" />
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ClientsSection;
